export default __webpack_public_path__ + "static/media/loha-web2.4de4b4c5.jpg";